import React from "react";

const Icon = (props: React.ComponentProps<'img'>) => {

    return (<img alt="icon" {...props}/>);
}

export default Icon;